import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import { AccessibilityToggle } from '../ui/AccessibilityToggle';
import { COPY } from '../../data/copy';

const SISTEMAS = [
  { label: 'Mapa Astral',           to: '/servicos/mapa-astral' },
  { label: 'Previsão Pessoal',      to: '/servicos/previsao-personalizada' },
  { label: 'Sinastria',             to: '/servicos/sinastria' },
  { label: 'Tarô de Marselha',      to: '/servicos/tarot-marselha' },
  { label: 'Tarot Cigano',          to: '/servicos/tarot-cigano' },
  { label: 'I Ching',               to: '/servicos/i-ching' },
  { label: 'Numerologia',           to: '/servicos/numerologia' },
  { label: 'Human Design',          to: '/servicos/human-design' },
  { label: 'Astrocartografia',      to: '/servicos/astrocartografia' },
  { label: 'Astrologia Védica',     to: '/servicos/astrologia-vedica' },
  { label: 'Astro Pet',             to: '/servicos/astro-pet' },
  { label: 'Pergunte aos Astros',   to: '/servicos/pergunte-aos-astros' },
  { label: 'Astromatch',            to: '/servicos/astromatch' },
  { label: 'Rota Profissional',     to: '/servicos/rota-profissional' },
  { label: 'Diário dos Sonhos',     to: '/servicos/diario-de-sonhos' },
  { label: 'Astro Coach',           to: '/servicos/astro-coach' },
  { label: 'Astros Retrógrados',    to: '/servicos/radar-retrogrado' },
  { label: 'Eclipse Insight',       to: '/servicos/eclipse-insight' },
  { label: 'Fases da Lua',          to: '/servicos/fases-da-lua' },
  { label: 'Grafologia',            to: '/servicos/grafologia' },
  { label: 'Agenda Astrológica',    to: '/servicos/agenda-astrologica' },
];

const EMPRESA = [
  { label: 'Como funciona',             to: '/#ritual' },
  { label: 'Assinatura',               to: '/pricing' },
  { label: 'Blog',                      to: '/blog' },
];

const LEGAL = [
  { label: 'Privacidade',        to: '/privacidade' },
  { label: 'Termos de uso',      to: '/termos' },
  { label: 'Cancelamento',       to: '/cancellation' },
];

const linkStyle: React.CSSProperties = {
  display: 'block',
  fontFamily: 'var(--font-body)',
  fontSize: 'max(16px, var(--text-13))',
  color: 'rgba(255,255,255,0.75)',
  textDecoration: 'none',
  marginBottom: '0.75rem',
  transition: 'color var(--transition-fast)',
  lineHeight: 1.5,
};

const headingStyle: React.CSSProperties = {
  fontFamily: 'var(--font-body)',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: 'rgba(255,255,255,0.45)',
  marginBottom: '1.25rem',
};

function InstagramIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.77a8.18 8.18 0 004.78 1.52V6.82a4.85 4.85 0 01-1.01-.13z" />
    </svg>
  );
}

export function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer style={{
      background: 'var(--navy)',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      padding: 'clamp(3rem, 6vw, 5rem) 2rem clamp(2rem, 4vw, 3rem)',
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        {/* Top grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 2fr 1fr',
          gap: '3rem',
          marginBottom: '3rem',
        }}
          className="footer-grid"
        >
          {/* Brand column */}
          <div>
            <p style={{
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              fontSize: 'var(--text-28)',
              color: '#fff',
              marginBottom: '0.75rem',
              lineHeight: 1.2,
            }}>
              Professya
            </p>
            <p style={{
              fontFamily: 'var(--font-body)',
              fontSize: 'max(16px, var(--text-13))',
              color: 'rgba(255,255,255,0.6)',
              lineHeight: 1.7,
              marginBottom: '1.25rem',
              maxWidth: '300px',
            }}>
              {COPY.footer.tagline}
            </p>
            <a
              href={`mailto:${COPY.footer.email}`}
              style={{ ...linkStyle, marginBottom: '1.25rem' }}
            >
              {COPY.footer.email}
            </a>
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', alignItems: 'center' }}>
              <a
                href="https://instagram.com/professya"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram da Professya"
                style={{ color: 'rgba(255,255,255,0.7)', transition: 'color var(--transition-fast)' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.7)'; }}
              >
                <InstagramIcon />
              </a>
              <a
                href="https://tiktok.com/@professya"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok da Professya"
                style={{ color: 'rgba(255,255,255,0.7)', transition: 'color var(--transition-fast)' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.7)'; }}
              >
                <TikTokIcon />
              </a>
            </div>
            <AccessibilityToggle />
          </div>

          {/* Sistemas */}
          <div>
            <p style={headingStyle}>Sistemas</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 1rem' }}>
              {SISTEMAS.map(l => (
                <Link key={l.to} to={l.to} style={linkStyle}
                  onMouseEnter={e => { (e.target as HTMLElement).style.color = '#fff'; }}
                  onMouseLeave={e => { (e.target as HTMLElement).style.color = 'rgba(255,255,255,0.75)'; }}
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Empresa + Legal */}
          <div>
            <p style={headingStyle}>Empresa</p>
            {EMPRESA.map(l => (
              <Link key={l.to} to={l.to} style={linkStyle}
                onMouseEnter={e => { (e.target as HTMLElement).style.color = '#fff'; }}
                onMouseLeave={e => { (e.target as HTMLElement).style.color = 'rgba(255,255,255,0.75)'; }}
              >
                {l.label}
              </Link>
            ))}
            <p style={{ ...headingStyle, marginTop: '1.5rem' }}>Legal</p>
            {LEGAL.map(l => (
              <Link key={l.to} to={l.to} style={linkStyle}
                onMouseEnter={e => { (e.target as HTMLElement).style.color = '#fff'; }}
                onMouseLeave={e => { (e.target as HTMLElement).style.color = 'rgba(255,255,255,0.75)'; }}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom row */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          paddingTop: '1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '0.75rem',
        }}>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: 'max(16px, var(--text-13))', color: 'rgba(255,255,255,0.45)', margin: 0 }}>
            {t('layout.footerCopyright', { year: String(year) })}
          </p>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: 'max(16px, var(--text-13))', color: 'rgba(255,255,255,0.45)', margin: 0, textAlign: 'right', maxWidth: '380px' }}>
            {t('layout.footerDisclaimer')}
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 767px) {
          .footer-grid { grid-template-columns: 1fr !important; gap: 2rem !important; }
        }
      `}</style>
    </footer>
  );
}
